(ns client-portal.client.voice-insights.concept.data
  (:require [shared.core.reactive :as re]))

(def root-path [:vi-concept])

(re/reg-event-fx
  :vi-concept/initialize re/middleware
  (fn [{:keys [db] :as world}]
    (if (get-in db (conj root-path :initialized?))
      world
      {:db (assoc-in db (conj root-path :initialized?) true)
       :forward-events {:register :vi-concept-initialization-listener
                        :events #{:concepts/select :core/select-crew-type
                                  :core/select-timeframe :voice-insights/select-day-part}
                        :dispatch-to [:voice-insights/reload-analytics]}})))
